import moment from "moment/moment";
import styles from "./styles/ListItemGroup.module.scss";
import React from "react";

export function ContentItemDate(props: {
    contentItem: ContentItem,
}) {
    const date = moment(props.contentItem.created_at).format('MMM D, YYYY');

    return <span className={styles.date}>
        {date}
    </span>
}